require('./event-edit.component');
require('./event-detail.component');
